<template>
  <div>
    <div class="flex items-center pb-twentyFive">
      <!-- TODO replace icon with component that has been created in Step 12-->
      <ExclamationIcon class="text-white bg-envelopeStatus-cancelled rounded-full h-base w-base p-xs mr-sm flex-shrink-0" />
      <i18n path="bulkSend.steps.reviewData.invalidRows" tag="p" class="mb-0">
        <template v-slot:count>
          <b>{{
              $t('bulkSend.steps.reviewData.rowCount', {
                count: meta.total,
                total: bulkSend.imported_rows_count
              })
            }}</b>
        </template>
        <template v-slot:link>
          <BaseButton
            variant="invisible"
            @click.native="downloadErrors"
            class="!p-0"
            data-ec="bulk_send_review_data_page"
            data-et="download_errors_link"
          >
            {{ $t('bulkSend.steps.reviewData.downloadACsv') }}
          </BaseButton>
        </template>
      </i18n>
    </div>
    <div>
      <div class="mb-twenty">
        <DataTable
          :rows="results"
          :columns="invalidComputedColumns"
        ></DataTable>
        <NumberedPaginator
          v-if="meta !== null && meta.last_page > 1"
          class="my-lg"
          :meta="meta"
          :resource="$t('bulkSend.steps.reviewData.invalidRowPagination')"
          page-data-ec="bulk_send_review_data_page_invalid_contacts"
          @page="$emit('page', $event)"
        />
      </div>
      <i18n path="bulkSend.steps.reviewData.updatedTheseErrors" tag="p" class="mb-twenty">
        <template v-slot:link>
          <RouterLink
            :to="prevRoute"
            data-ec="bulk_send_review_data_page"
            data-et="upload_csv_again_link"
          >{{ $t('bulkSend.steps.reviewData.uploadYourCsvAgain') }}</RouterLink>
        </template>
      </i18n>
    </div>
  </div>
</template>

<script>
import NumberedPaginator from '@/components/ui/pagination/Paginator.vue';
import DataTable from '@/components/library/dataTables/DataTable.vue';
import { mapGetters } from 'vuex';
import { h } from 'vue';
import ErrorTableCell from '@/components/ui/bulkSend/ErrorTableCell.vue';
import BaseButton from '@/components/library/buttons/BaseButton.vue';
import useBulkSendRoutes from '@/composables/bulkSend/routes';
import kebabCase from 'lodash/kebabCase';
import download from '@/utils/download';
import { ExclamationIcon } from '@/components/icons/fontIcons';

export default {
  name: 'InvalidBulkSendRows',
  components: {
    BaseButton,
    DataTable,
    NumberedPaginator,
    ExclamationIcon,
  },
  props: {
    meta: {
      type: Object,
      required: true,
    },
    results: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const { prevRoute } = useBulkSendRoutes();

    return {
      prevRoute,
    };
  },
  computed: {
    ...mapGetters({
      bulkSend: 'bulkSend/bulkSend',
    }),
    invalidComputedColumns() {
      return this.meta.headings.map((heading) => {
        if (heading.field === 'error_count') {
          return {
            heading: heading.title,
            render: count => this.$tc('bulkSend.steps.reviewData.noOfErrors', count, { count }),
          };
        }

        return {
          heading: heading.title,
          render: (value) => {
            if (typeof value === 'string' || typeof value === 'number') {
              return value;
            }

            if (typeof value === 'object') {
              if (value.errors && value.errors.length > 0) {
                return h(
                  ErrorTableCell,
                  {
                    props: {
                      error: value.errors[0],
                      value: value.value,
                    },
                  },
                );
              }
              return value.value;
            }

            return value.title;
          },
        };
      });
    },
  },
  methods: {
    async downloadErrors() {
      await download({
          url: `bulk-sends/${this.bulkSend.fingerprint}/imported-rows/csv-data/download-errors`,
          params: undefined,
          fileName: kebabCase(`${this.bulkSend.name}-errors`),
        });
    },
  },
};
</script>

<style scoped>

</style>
